// extracted by mini-css-extract-plugin
module.exports = {"scroll_area":"Main_scroll_area__3Cgfx"};